import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import {  Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateLeadFields } from 'bundles/project/actions/leads';
import { createDropdownItems } from './helper';
import AccessLevelToShow from './access_level_to_show';
import { createPortal } from 'react-dom';

function DocumentProgress({ columnName, lead, leaseAccessLevels, saleAccessLevels, onUpdate, externalOnUpdate }) {
  const [saving, setSaving] = useState(false);
  const isSale = columnName.toLowerCase().includes('sale');
  const accessLevels = isSale ? saleAccessLevels : leaseAccessLevels;

  const psuedoColumnName = isSale ?
    'saleVaultGatesAccessLevelWithoutOverride' :
    'leaseVaultGatesAccessLevelWithoutOverride';
  const psuedoValue = lead[psuedoColumnName];
  const value = lead[columnName];
  const isPinned = value !== 'no_override';
  const uniqueId = `${psuedoColumnName}-${lead.id}`;
  const valueToShow = isPinned ? value : psuedoValue;

  if (valueToShow === 'no_override') return null;

  if (saving) {
    return (
      <div className="text-center">
        <FontAwesomeIcon icon={faSpinner} size="lg" spin/>
      </div>
    );
  }

  if (!accessLevels || accessLevels.length === 0) {
    return <AccessLevelToShow isPinned={isPinned} uniqueId={uniqueId} valueToShow={valueToShow}/>;
  }

  const modifyAccessLevel = (value) => {
    setSaving(true);

    if (externalOnUpdate) {
      externalOnUpdate(lead, { [columnName]: value });
      setSaving(false);
    } else {
      onUpdate(lead, { [columnName]: value }).finally(() => setSaving(false));
    }
  };

  const dropdownMenuItems = createDropdownItems(isPinned, value, modifyAccessLevel, accessLevels);

  return (
    <div className="d-flex justify-content-between align-items-center">
      <AccessLevelToShow isPinned={isPinned} uniqueId={uniqueId} valueToShow={valueToShow}/>

      <OverlayTrigger
        overlay={
          <Tooltip id={`tooltip-${uniqueId}`}>
            Note: overriding a lead's progress will lock them to that
            progress. They will not be able to progress further until they are unpinned
          </Tooltip>
        }
        placement="top"
      >
        <Dropdown>
          <Dropdown.Toggle id={`dropdown-${uniqueId}`}  variant="ghost">
            <FontAwesomeIcon className="text-primary" icon={faEdit} size="lg" />
          </Dropdown.Toggle>
          {createPortal(
            <Dropdown.Menu>
              {dropdownMenuItems.map(item => (
                <Dropdown.Item key={item.key} onClick={item.onClick}>
                  {item.content}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
            , document.body)}
        </Dropdown>
      </OverlayTrigger>
    </div>
  );
}

DocumentProgress.propTypes = {
  columnName: PropTypes.string,
  externalOnUpdate: PropTypes.func,
  lead: PropTypes.object,
  leaseAccessLevels: PropTypes.arrayOf(PropTypes.string),
  saleAccessLevels: PropTypes.arrayOf(PropTypes.string),
  onUpdate: PropTypes.func
};

const mapStateToProps = ({ project }) => ({
  saleAccessLevels: project?.saleVault?.accessLevels,
  leaseAccessLevels: project?.leaseVault?.accessLevels
});

const mapDispatchToProps = {
  onUpdate: updateLeadFields
};



export default connect(mapStateToProps, mapDispatchToProps)(DocumentProgress);
